export default __webpack_public_path__ + "static/media/grid-filter.64111df3.svg";